import { clsx } from 'clsx';
import { forwardRef } from 'react';

import type { TableBodyProps } from '../table.types';

import styles from './tableBody.module.css';

export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(
  function TableBody(
    { children, className, 'data-testid': testId, id, style },
    ref
  ) {
    return (
      <tbody
        ref={ref}
        className={clsx(className, styles['tableBody'])}
        data-testid={testId}
        id={id}
        style={style}
      >
        {children}
      </tbody>
    );
  }
);
